import PropTypes from "prop-types";
import React from "react";
import FormField from "./FormField";

const YearField = ({name, label, student, required}) => {
  // Limit years to 5 options starting one year ago
  const startYear = new Date().getFullYear() - 1;
  const years = Array.from({length: 5}, (_, i) => startYear + i);
  if (student && student.apply_year && !years.includes(student.apply_year)) {
    years.push(student.apply_year);
  }

  return (
    <FormField label={label} type="select" name={name} options={years.map(y => y.toString())} colWidth={6} required={required} />
  );
};

YearField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool
};

YearField.defaultProps = {
  required: false
};

export default YearField;
